// library imports
import { Skeleton, Flex, Divider, Tabs, Select, Row, Col } from "antd";
// component import
import WeatherStationTable from "./WeatherStationTable";
import { LabelValueUnitDisplayRow } from "../../common/WordDisplay";

export default function WeatherStationContent({
  devicePhaseNumberList,
  deviceList,
  systemData,
  tableData,
  handleDeviceChange,
  weatherStationSystemLoading,
  weatherStationDeviceLoading,
  deviceSelectionLoading,
  selectedDeviceID,
  systemLastUpdate,
  deviceLastUpdate,
  setPhaseNumberSelected,
}) {
  return (
    <div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          align: "center",
          marginBottom: "12px",
        }}
      >
        <h2 style={{ margin: "0px" }}>Weather Station</h2>
        <span>Last Update: {systemLastUpdate}</span>
      </div>
      {weatherStationSystemLoading ? (
        <Skeleton active style={{ margin: "5px" }} />
      ) : (
        <Row gutter={[24, 24]}>
          <Col xs={24} sm={24} md={24} lg={12} xl={12} xxl={8}>
            <LabelValueUnitDisplayRow
              label={"Average Daily Irradiance - Month"}
              value={
                systemData?.averageDailyIrradiance !== undefined
                  ? systemData.averageDailyIrradiance
                  : "-"
              }
              unit={"kWh/m²/day"}
            />
            <LabelValueUnitDisplayRow
              label={"Average Daylight Irradiance - Month"}
              value={
                systemData?.averageDaylightIrradiance !== undefined
                  ? systemData.averageDaylightIrradiance
                  : "-"
              }
              unit={"W/m²"}
            />
            <LabelValueUnitDisplayRow
              label={"Maximum Irradiance - Month"}
              value={
                systemData?.maxIrradiance !== undefined
                  ? systemData.maxIrradiance
                  : "-"
              }
              unit={"kWh/m²"}
            />
            <LabelValueUnitDisplayRow
              label={"Minimum Irradiance - Month"}
              value={
                systemData?.minIrradiance !== undefined
                  ? systemData.minIrradiance
                  : "-"
              }
              unit={"kWh/m²"}
            />
          </Col>

          <Col xs={24} sm={24} md={24} lg={12} xl={12} xxl={8}>
            <LabelValueUnitDisplayRow
              label={"Average Ambient Temperature - Month"}
              value={
                systemData?.averageAmbientTemp !== undefined
                  ? systemData.averageAmbientTemp
                  : "-"
              }
              unit={"°C"}
            />
            <LabelValueUnitDisplayRow
              label={"Average Module Temperature - Month"}
              value={
                systemData?.averageModuleTemp !== undefined
                  ? systemData.averageModuleTemp
                  : "-"
              }
              unit={"°C"}
            />
            <LabelValueUnitDisplayRow
              label={"Average Wind Speed - Month"}
              value={
                systemData?.averageWindSpeed !== undefined
                  ? systemData.averageWindSpeed
                  : "-"
              }
              unit={"m/s"}
            />
          </Col>
        </Row>
      )}

      <div>
        <Divider />
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            align: "center",
          }}
        >
          <h2 style={{ margin: "0px" }}>Weather Station Main Parameters</h2>
          <span>Last Update: {deviceLastUpdate}</span>
        </div>
        {/* <Tabs
          items={devicePhaseNumberList}
          onChange={(key) => setPhaseNumberSelected(key)}
        /> */}
        <Flex justify="space-between" align="center" className="mt-3 mb-3">
          {deviceList.length > 0 && selectedDeviceID ? (
            <Select
              loading={deviceSelectionLoading}
              onChange={(value) => handleDeviceChange(value)}
              value={selectedDeviceID}
              options={deviceList}
              style={{ width: "100%", marginRight: "8px" }}
            />
          ) : (
            <></>
          )}
        </Flex>
        {weatherStationDeviceLoading ? (
          <Skeleton active style={{ margin: "5px" }} />
        ) : (
          <WeatherStationTable data={tableData} />
        )}
      </div>
    </div>
  );
}
